import React from 'react';
import { Tooltip, Button } from '@mui/material';
import styled from 'styled-components';

// Styled Button
const StyledButton = styled(Button)({ 
  height: "30px",
  boxShadow: "none",
});

const AccessRestrictedButton = ({ disabled, ...props }) => (
  <Tooltip title={disabled ? "You don't have access to edit" : ""}>
    <span>
      <StyledButton variant="contained" disabled={disabled} {...props} />
    </span>
  </Tooltip>
);

export default AccessRestrictedButton;
